/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query getPopupProjects($filters: FiltersInput!) {
    projects(filters: $filters) {
      id
      name
      latlon
      pageType
      resourceId
      status
      category
      fillColor
      address
      propertyAddress
      teaserPhoto
    }
  }
`): DocumentNode);
